module.exports = __webpack_public_path__ + "assets/icons/guaranteed-safe-updated-small.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/icons/guaranteed-safe-updated-small.png
// module id = ./src/styles/icons/guaranteed-safe-updated-small.png
// module chunks = 0